<template>
	<el-container>
		<div class="colhead">
			<h2 class="header_h2">订单审核管理</h2>
		</div>
		<el-header>
			企业：<el-select style=" width: 200px;  height:30px;" v-model="curcorpid"
				v-on:change="refreshWaitApproveOrder">
				<el-option v-for="item in CorpData" :label="item.corp_name" :value="item.corp_id"
					placeholder="请选择">
					{{ item.corp_name }}
				</el-option>
			</el-select>
			<!-- <el-button type="primary" style="margin:10px 5px 0px 10px;float: left;" @click="baonewAdd">新增</el-button> -->
			<el-input v-model="txtQOrderName" placeholder="请输入方案名称过滤查找" v-on:input="btnQOrderName"
				style="display:inline-block;width:350px;float: left;"></el-input>
	<el-input v-model="txtApproveMemo" placeholder="请输入审核备注信息"
		style="display:inline-block;width:350px;float: left;"></el-input>
		</el-header>
	<el-main>

			<el-table border ref="multipleTable" tooltip-effect="dark" @select="select" @select-all="select"
				:data="lists.slice((currentPage-1)*pagesize,currentPage*pagesize)">
				<!-- <el-table-column prop="IsChecked" label="选择" width="50">
							<input type="checkbox" value="IsChecked" color="#FFCC33" style="float:left;transform:scale(0.7)" v-model='IsChecked'
							 v-bind:checked="IsChecked" @click="onCheckedChange(subIndex,$event)"></input>

						</el-table-column> -->
				<!-- <el-table-column type="selection"></el-table-column> -->
				<el-table-column prop="OrderName" label="方案名称" width="120px"></el-table-column>
				<!-- <el-table-column prop="OrderState" label="方案状态">
					<template slot-scope="scope">
						<label v-if='scope.row.OrderState=="0"'>创建方案</label>
						<label v-if='scope.row.OrderState=="1"'>提交方案</label>
						<label v-if='scope.row.OrderState=="2"'>审核通过</label>
						<label v-if='scope.row.OrderState=="3"'>可以体检</label>
					</template>
				</el-table-column> -->
				<el-table-column prop="Memo" label="备注" width="200px"></el-table-column>
				<el-table-column prop="SalerName" label="业务员"></el-table-column>
				<el-table-column prop="CommitDate" label="提交时间" width="100px"></el-table-column>
				<!-- <el-table-column prop="ApproveName" label="审核人"></el-table-column>
				<el-table-column prop="ApproveDate" label="审核时间" width="100px"></el-table-column>
				 -->
				<el-table-column label="操作" width="180px">
					<template slot-scope="scope">
						<el-button @click="btnApprove(scope.$index,scope.row)" type="text" size="small">审核通过</el-button>
						<!-- <el-button @click="btnCanCheck(scope.row)" type="text" size="small">可以体检</el-button> -->
						<el-button @click="btnOrderReport(scope.row)" type="text" size="small">方案详情</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-footer style="margin-top:20px;">
				<template>
					<div class="block">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
							:current-page="currentPage" :page-sizes="[5, 10, 20, 40]" :page-size="pagesize"
							layout="total, sizes, prev, pager, next, jumper" :total="lists.length"></el-pagination>
					</div>
				</template>
			</el-footer>
	
		<RouterView></RouterView>
	</el-main>
	</el-container>
</template>
<script>
	import orderdata from '../../apifunction/Order.js'
	import corp from '../../apifunction/Corp.js'
	export default {
		created() {
			this.getAllCorp();


		},
		data() {
			return {
				CorpData: [],
				curcorpid: '',
				// OrderState: this.$enums.OrderState,
				OState: -1,
				currentPage: 1,
				pagesize: 10,
				txtQOrderName: '',
				txtApproveMemo: '',
				lists: [],
				listAll: []
			}
		},
		methods: {
			getAllCorp() {
				corp.GetAllCorp()
					.then(res => {
						//alert(JSON.stringify(res.data))
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data != 'null')
								this.CorpData = JSON.parse(ent.Data);


						} else
							this.$message.info(ent.Msg);
					})
			},
			refreshWaitApproveOrder() {
				if(this.curcorpid=='')
				return;
				orderdata.GetWaitApproveOrder(this.curcorpid)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data != 'null') {
								this.listAll = JSON.parse(ent.Data);
								this.lists = JSON.parse(JSON.stringify(this.listAll));
							}

						} else
							this.$message.info(ent.Msg);
					});
			},
			handleSizeChange: function(size) {
				this.pagesize = size;
			},
			handleCurrentChange: function(currentPage) {
				this.currentPage = currentPage;
			},
			btnQOrderName: function() {
				if (this.listAll == [])
					return;
				// this.$nextTick(function() {
				if (this.txtQOrderName == '') {
					this.lists = JSON.parse(JSON.stringify(this.listAll));
					// return
				} else {

					var templist = this.listAll.filter(item => {
						// alert(item.OrderName);
						// if (py.chineseToPY(item.OrderName).indexOf(py.chineseToPY(this.txtQOrderName)) > -1) 
						if (item.OrderName.indexOf(this.txtQOrderName) > -1) {
							return item
						}
					});
					this.lists = JSON.parse(JSON.stringify(templist));
				}
			},
			btnOrderReport: function(item) {
				var data = {
					path: '/OrderReport',
					query: {
						ent: JSON.stringify(item)
					}
				};
				this.$router.replace(data)
			},
			btnApprove: function(index, item) {
				var entord = JSON.parse(JSON.stringify(item))
				entord.ApproveID = this.$myglobal.getUserInfo().id;
				entord.ApproveName = this.$myglobal.getUserInfo().username;
				entord.ApproveDate = this.CommonFun.GetNowDateTime();
				entord.OrderState = '2';
				entord.ApproveMemo = this.txtApproveMemo;
				// alert(JSON.stringify(entord))
				orderdata.ApproveOrder(entord)
					.then(res => {
						// alert(JSON.stringify(res.data))
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.$message.info('审核成功！');
							item.ApproveID = entord.ApproveID;
							item.ApproveName = entord.ApproveName;
							item.ApproveDate = entord.ApproveDate;
							item.ApproveMemo = entord.ApproveMemo;
							item.OrderState = entord.OrderState;
							this.lists.splice(index, 1);
							var idx = this.listAll.findIndex(itm => {
								if (item.OrderID == itm.OrderID) {
									return true;
								}
							})

							this.listAll.splice(idx, 1);
						} else
							this.$message.info(ent.Msg);
					})
			},
			btnCanCheck: function(item) {
				if (item.OrderState == '2')
					item.OrderState = '3';
				else
					this.$message.info('请选择‘审核通过’方案做此操作！')
			},
		}	}
</script>
<style>
	
</style>
